import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = () => {
  const { user: mainUser } = useAuth();
  const user = localStorage.getItem("user");
  console.log(user, 'mainUser');

  // Handle both null and "null" strings as well as context state
  const isUserAuthenticated = (user && user !== "null" && user !== "undefined") || !!mainUser;

  return isUserAuthenticated ? <Outlet /> : <Navigate to="/pages/signin2" replace />;
};

export default ProtectedRoute;
